import apiNewton from "./apiNewton";

export const setCreateCredential = (data) =>
	apiNewton.post("students/insertCreateCredential", data);

export const getBinnacleCredential = (params) =>
	apiNewton.get("students/selectBinnacleCredentialStudent", {
		params: params,
	});

export const getBinnacleCalification = (params) =>
	apiNewton.get("courses/selectBinnacleCalificationUser", { params: params });

export const getMessageBlockedUser = (params) =>
	apiNewton.get("students/selectMessageBlockedUser", { params: params });
